import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { focusHook } from '@/atoms';

export const reportsAtom = atomFamily((_scopeKey: string) =>
  atom({
    licenseeModeToggle: false,
  }),
);

export const reportsPlansAtom = reportsAtom('plans');
export const reportsTeamMembersAtom = reportsAtom('teamMembers');

export const useReportsPlansFocus = focusHook(reportsPlansAtom);
export const useReportsTeamMembersFocus = focusHook(reportsTeamMembersAtom);
